import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
const testimonials = [{
  id: 1,
  name: 'Elena R., 42 años',
  status: 'Se quedó',
  statusColor: 'bg-brand-amber/20 text-brand-amber border-brand-amber/30',
  image: 'https://cdn.magicpatterns.com/uploads/bsgLzJS1jZU5yCnuH4MrRP/testimonio_engano_elena_1.png',
  title: 'La claridad que no me daba el llanto',
  text: "Cuando descubrí los mensajes, mi mundo se apagó. No podía comer ni dormir. El libro de Freddy fue el primer lugar donde no me sentí juzgada por querer entender 'por qué'. Pero fue la asesoría personalizada con Freddy la que me dio el valor de poner límites. Decidimos darnos una oportunidad bajo sus reglas de 'Transparencia Radical' y hoy, un año después, nuestra relación es más honesta que nunca. Gracias, Freddy, por salvarnos del divorcio."
}, {
  id: 2,
  name: 'Ricardo M., 38 años',
  status: 'Se fue',
  statusColor: 'bg-rose-500/20 text-rose-400 border-rose-500/30',
  image: 'https://cdn.magicpatterns.com/uploads/jFZdDRQoUpTehjCc2SG9bN/ricardo_testimonio_2_.png',
  title: 'Recuperar mi dignidad no tuvo precio',
  text: "Yo estaba atrapado en la culpa y la duda. Pensaba que si me iba, fracasaba como padre. El manual me abrió los ojos sobre la 'viabilidad relacional'. Tras una sesión privada con Freddy, entendí que mi paz mental era innegociable. Decidí irme y fue la mejor decisión de mi vida. Hoy soy un mejor padre porque volví a ser un hombre íntegro. El apoyo de Freddy fue mi brújula en la tormenta."
}, {
  id: 3,
  name: 'Claudia S., 35 años',
  status: 'Se quedó',
  statusColor: 'bg-brand-amber/20 text-brand-amber border-brand-amber/30',
  image: 'https://cdn.magicpatterns.com/uploads/awaPB1PEeDbyDUN6okGD8S/claudia_testimonio_3.png',
  title: 'De la obsesión a la paz',
  text: "Vivía revisando el celular de mi esposo cada 5 minutos. Era una enfermedad. El método 'DETENTE' del libro me devolvió el sueño, pero la mentoría con Freddy me quitó la venda de los ojos. Me ayudó a ver que mi pareja tenía un arrepentimiento real y me enseñó cómo perdonar sin sentirme débil. Estamos reconstruyendo algo hermoso sobre bases nuevas."
}, {
  id: 4,
  name: 'Mariana V., 29 años',
  status: 'Se fue',
  statusColor: 'bg-rose-500/20 text-rose-400 border-rose-500/30',
  image: 'https://cdn.magicpatterns.com/uploads/h1e93wBcyGRBAmbD8X5jKH/mariana_testimonio_4.png',
  title: 'El fin de una mentira de años',
  text: "Llevaba años sospechando y perdonando 'micro-infidelidades'. Con el paso 5 del libro supe que mi relación era un barril sin fondo. Freddy me acompañó en el proceso de separación con una firmeza que yo no tenía. No solo compré un PDF, contraté a un aliado que me ayudó a no volver atrás cuando me sentía sola. Hoy soy libre."
}, {
  id: 5,
  name: 'Jorge L., 45 años',
  status: 'Se quedó',
  statusColor: 'bg-brand-amber/20 text-brand-amber border-brand-amber/30',
  image: 'https://cdn.magicpatterns.com/uploads/bb13eRGYPa5ctWKy5tVXSg/jorge_testimonio_5_.png',
  title: 'Fui quien falló, y Freddy me enseñó a reparar',
  text: "Yo cometí la infidelidad y estaba destruido por la culpa y el rechazo de mi esposa. En la asesoría con Freddy, aprendí que 'pedir perdón' no basta, hay que 'reparar con hechos'. Siguiendo su protocolo de 7 pasos, logré que mi esposa volviera a confiar en mí. No fue fácil, pero Freddy nos dio el lenguaje para volver a hablarnos sin gritarnos."
}, {
  id: 6,
  name: 'Camila P., 33 años',
  status: 'Se fue',
  statusColor: 'bg-rose-500/20 text-rose-400 border-rose-500/30',
  image: 'https://cdn.magicpatterns.com/uploads/j1etiPaCeJtqKK47FZf2WM/camila_testimonio_6_.png',
  title: 'Cerrar la puerta sin mirar atrás',
  text: "Lo que más me asustaba era el 'qué dirán'. El libro me dio la estructura lógica y Freddy me dio el empujón emocional. Entendí que perdonar no significa quedarse donde te lastiman. Me fui con la frente en alto y con un plan de vida claro. Si estás dudando, habla con Freddy; él sabe cómo sacarte del caos rápidamente."
}];
export function TestimonialsSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-brand-dark" data-id="element-192">
      <div className="max-w-3xl mx-auto" data-id="element-193">
        <FadeIn data-id="element-194">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-brand-amber text-center mb-16" data-id="element-195">
            Lo Que Dicen Quienes Ya Dieron El Paso
          </h2>
        </FadeIn>

        <div className="space-y-8" data-id="element-196">
          {testimonials.map((testimonial, index) => <FadeIn key={testimonial.id} delay={index * 0.1} data-id="element-197">
              <div className="bg-[#1a1a1a] border border-brand-amber/10 rounded-2xl p-6 sm:p-8 flex flex-col sm:flex-row gap-6 sm:gap-8 items-center sm:items-start" data-id="element-198">
                <div className="flex-shrink-0 flex flex-col items-center gap-3" data-id="element-199">
                  <img src={testimonial.image} alt={testimonial.name} className="w-20 h-20 rounded-full object-cover border-2 border-brand-amber/30 shadow-lg" data-id="element-200" />
                  <span className={`text-xs font-bold px-3 py-1 rounded-full border ${testimonial.statusColor}`} data-id="element-201">
                    {testimonial.status}
                  </span>
                </div>

                <div className="flex-1 text-center sm:text-left" data-id="element-202">
                  <div className="flex justify-center sm:justify-start gap-1 mb-3" data-id="element-203">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-amber text-brand-amber" data-id="element-204" />)}
                  </div>

                  <h3 className="text-xl font-bold text-brand-offwhite mb-3" data-id="element-205">
                    "{testimonial.title}"
                  </h3>

                  <p className="text-brand-offwhite/80 leading-relaxed mb-4 italic" data-id="element-206">
                    "{testimonial.text}"
                  </p>

                  <p className="text-sm font-bold text-brand-offwhite/60" data-id="element-207">
                    — {testimonial.name}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}